/* eslint-disable react/prop-types */
import React from 'react';
import _ from 'lodash';
import { formatDate } from '@applyboard/ab-common';
import CompactTestScores from "../../../../../components/CompactTestScores";
import Table from "../../Table";
import { TableWrapper, SidebarExtraInfoSeperator } from "../../styles";
var TestContent = function TestContent(_ref) {
  var testScores = _ref.testScores;
  if (_.isEmpty(testScores.additionalQualifications)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(TableWrapper, null, /*#__PURE__*/React.createElement(SidebarExtraInfoSeperator, null, "Additional Qualifications"), /*#__PURE__*/React.createElement(ScoresTable, {
    scores: testScores.additionalQualifications.gre,
    type: "gre"
  }), /*#__PURE__*/React.createElement(ScoresTable, {
    scores: testScores.additionalQualifications.gmat,
    type: "gmat"
  }));
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var ScoresTable = function ScoresTable(_ref2) {
  var scores = _ref2.scores,
    type = _ref2.type;
  if (!scores) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Table, {
    extraInfo: true,
    info: [{
      name: 'Exam Type',
      value: type.toUpperCase()
    }, {
      name: 'Scores',
      value: /*#__PURE__*/React.createElement(CompactTestScores, {
        testScores: scores,
        type: type,
        column: true
      })
    }, {
      name: 'Exam Date',
      value: formatDate(scores.exam_date) || ''
    }]
  });
};
export default TestContent;